export default function linkBackFormat(url: string, returnText: string) {
  const returnUrl = globalThis.location.href;
  const returnToText = `Return to ${returnText}`;
  return `${url}?return_text=${encodeURIComponent(
    returnToText
  )}&return_url=${encodeURIComponent(returnUrl)}`;
}
